export enum SendLeadModalEnum {
  GROUPE_MUTUEL = 'GROUPE_MUTUEL',
  // Add future insurer modal values here
}
